import { createSlice } from '@reduxjs/toolkit';
import { themeEnum } from 'shared/utils/Enum';

const initState = {
    theme: themeEnum.Light
};

export const themeSlice = createSlice({
    name: 'theme',
    initialState: initState,
    reducers: {
        setTheme: (state, action) => {
            let tempObj = { ...state, ...action.payload };
            return tempObj;
        },
        resetTheme: () => initState
    }
});

export const { setTheme, resetTheme } = themeSlice.actions;

export default themeSlice.reducer;
